import * as React from "react";
import { SVGProps } from "react";

export const EventAudienceSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={42}
		height={42}
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width={42} height={42} rx={6} fill="#0050FF" fillOpacity={0.08} />
		<path
			opacity={0.32}
			d="M11.281 28.5149C11.3697 29.3735 11.9326 30.0532 12.7769 30.2329C14.1095 30.5166 16.6216 30.8574 21 30.8574C25.3784 30.8574 27.8905 30.5166 29.2232 30.2329C30.0674 30.0532 30.6304 29.3735 30.719 28.5149C30.8505 27.2418 31 24.9044 31 20.8574C31 16.8105 30.8505 14.473 30.719 13.1999C30.6304 12.3413 30.0674 11.6617 29.2231 11.4819C27.8905 11.1982 25.3784 10.8574 21 10.8574C16.6216 10.8574 14.1095 11.1982 12.7769 11.4819C11.9326 11.6617 11.3697 12.3413 11.281 13.1999C11.1495 14.473 11 16.8105 11 20.8574C11 24.9044 11.1495 27.2418 11.281 28.5149Z"
			fill="#0050FF"
			fillOpacity={0.48}
		/>
		<path
			d="M22.9382 22.7133C24.263 22.0157 25.1663 20.6254 25.1663 19.0241C25.1663 16.7229 23.3008 14.8574 20.9996 14.8574C18.6984 14.8574 16.8329 16.7229 16.8329 19.0241C16.8329 20.6254 17.7363 22.0158 19.0612 22.7134C17.2869 23.3894 15.9322 24.9666 15.5125 26.9103C15.4545 27.1793 15.6025 27.4555 15.8734 27.5045C16.8458 27.6805 18.4562 27.8574 21.0006 27.8574C23.545 27.8574 25.1554 27.6805 26.1278 27.5045C26.3977 27.4557 26.5454 27.1806 26.4876 26.9125C26.0685 24.9677 24.7133 23.3895 22.9382 22.7133Z"
			fill="#0050FF"
			fillOpacity={0.48}
		/>
	</svg>
);
